import type {
  IHistory,
  IHistoryGallery,
  IHistoryHighlight,
  IHistoryPages,
  IHistoryPresidents,
  IPageInfo,
} from '@/types';
import { presidents } from './president';

const pageOne: IPageInfo = {
  title: 'TITULO TITULO',
  description:
    '\u003Cp\u003ELorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore&nbsp;\u003Cbr\u003E\u003Cbr\u003ELorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore&nbsp;\u003C/p\u003E',
  image_one: {
    path: 'https://admin.fpf.gemadigital.com/uploads/dummy/1.png',
    mime_type: 'image/png',
    caption: '',
  },
  image_two: {
    path: 'https://admin.fpf.gemadigital.com/uploads/dummy/2.jpg',
    mime_type: 'image/jpeg',
    caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
  },
  image_three: {
    path: 'https://admin.fpf.gemadigital.com/uploads/dummy/3.jpg',
    mime_type: 'image/jpeg',
    caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
  },
};

const pageTwo: IPageInfo = {
  title: 'TITULO TITULO',
  description:
    '\u003Cp\u003EEt dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco\u003Cbr\u003E\u003Cbr\u003ELorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.\u003C/p\u003E',
  image_one: {
    path: 'https://admin.fpf.gemadigital.com/uploads/dummy/4.jpg',
    mime_type: 'image/jpeg',
    caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
  },
  image_two: {
    path: 'https://admin.fpf.gemadigital.com/uploads/dummy/5.jpg',
    mime_type: 'image/jpeg',
    caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
  },
  image_three: {
    path: 'https://admin.fpf.gemadigital.com/uploads/dummy/6.jpg',
    mime_type: 'image/jpeg',
    caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
  },
};

export const historyPages: IHistoryPages = {
  page: { one: pageOne, two: pageTwo },
};

export const historyPresidents: IHistoryPresidents = {
  presidents: presidents,
};

export const historyGallery: IHistoryGallery = {
  gallery: [
    {
      caption: '',
      path: '/gallery/game1.png',
      mime_type: 'image/jpeg',
    },
    {
      caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
      path: '/gallery/game2.png',
      mime_type: 'image/jpeg',
    },
    {
      caption: '',
      path: '/gallery/game4.png',
      mime_type: 'image/jpeg',
    },
    {
      caption: 'Punakaiki Coast',
      path: 'https://images.unsplash.com/photo-1707007694363-b8afb46ed639?q=80&w=2971&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      mime_type: 'image/jpeg',
    },
    {
      caption: 'Golden Hour',
      path: 'https://images.unsplash.com/photo-1522747776116-64ee03be1dad?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      mime_type: 'image/jpeg',
    },
  ],
};

export const historyHighlight: IHistoryHighlight = {
  highlight: {
    media_1: {
      caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
      path: '/gallery/game1.png',
      mime_type: 'image/jpeg',
    },
    media_2: {
      caption: 'Et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco',
      path: '/gallery/game2.png',
      mime_type: 'image/jpeg',
    },
  },
};

export const histories: IHistory[] = [
  {
    ...historyPages,
    ...historyPresidents,
    ...historyGallery,
    ...historyHighlight,
  },
  {
    ...historyPages,
    ...historyPresidents,
    ...historyGallery,
    ...historyHighlight,
  },
  {
    ...historyPages,
    ...historyPresidents,
    ...historyGallery,
    ...historyHighlight,
  },
  {
    ...historyPages,
    ...historyPresidents,
    ...historyGallery,
    ...historyHighlight,
  },
];
